import { Splide } from "@splidejs/splide";


const carousel = () => {
  const targetElms = document.getElementsByClassName('js-sliderBasic');
  if(targetElms.length === 0) return;
  for(const targetElm of targetElms) {
    const speed = 400;
    let options = {
      type: "slide",
      speed: speed,
      rewindSpeed: speed,
      autoWidth: true,
      gap: "0.5rem",
      arrows: false,
      pagination: false,
      autoplay: true,
      reducedMotion: {
        speed: speed,
        rewindSpeed: speed,
      }
    }
    if(targetElm.dataset.speed) {
      options.speed = parseInt(targetElm.dataset.speed);
      options.rewindSpeed = parseInt(targetElm.dataset.speed);
      options.reducedMotion.speed = parseInt(targetElm.dataset.speed);
      options.reducedMotion.rewindSpeed = parseInt(targetElm.dataset.speed);
    }

    if(targetElm.dataset.gap) {
      options.gap = targetElm.dataset.gap;
    }

    if(targetElm.dataset.gapSp) {
      options.breakpoints = {
        768: {
          gap: targetElm.dataset.gapSp,
        }
      };
    }

    if(targetElm.dataset.arrows === "true") {
      options.arrows = true;
    }

    if(targetElm.dataset.pagination === "true") {
      options.pagination = true;
    }
    if(targetElm.dataset.autoplay === "false") {
      options.autoplay = false;
    }

    if(targetElm.dataset.perMove) {
      options.perMove = parseInt(targetElm.dataset.perMove);
    }

    if(targetElm.dataset.perMoveSp) {
      if(!options.breakpoints) options.breakpoints = {};
      if(!options.breakpoints[768]) options.breakpoints[768] = {};
      options.breakpoints[768].perMove = parseInt(targetElm.dataset.perMoveSp);
    }

    if(targetElm.dataset.loop === "true") {
      options.type = "loop";
    }

    const slider = new Splide(targetElm, options);
    slider.mount();
  }
}

const init = () => {
  carousel();
}
export default init;